import { gql } from "@apollo/client"

export const DELETE_PRODUCT = gql`
  mutation($storeId: String!, $id: String!) {
    deleteMenuItem(restaurantId: $storeId, menuItemId: $id) {
      id
    }
  }
`
